import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
import { from, Subscription } from 'rxjs';
import { TwoActionModalComponent } from '../../../shared/components/modals/two-action-modal/two-action-modal.component';
import {
  AppointmentTimeSlot,
  IOfficeInfo
} from '../../../core/interfaces/IOfficeItem.interface';
import { AppointmentTimeSlotService } from '../../../core/services/appointments/appointment-timeslot.data.service';
import { OfficeLocationDataService } from '../../../core/services/data/office-locations.data.service';
import { CalendarService } from '../../../core/services/calendar.service';
import Utils from '../../../shared/utilities/utils';
import { AmsDataService } from 'src/app/core/services/appointments/ams.data.service';
import { IAppointmentDetails } from 'src/app/core/interfaces/IAppointments.interface';

@Component({
    selector: 'app-home',
    templateUrl: './calendar.page.html',
    styleUrls: ['./calendar.page.scss'],
    standalone: false
})
export class CalendarPage<D> implements OnInit, OnDestroy {
  public currentOffice: IOfficeInfo;
  public isModifyFlow: boolean = false;
  private subscriptionList: Subscription[] = [];
  public rootPage: string;
  public device: string;

  //#region Initialization

  constructor(
    private officeLocationService: OfficeLocationDataService,
    private appointmentTimeSlotService: AppointmentTimeSlotService,
    private router: Router,
    private modalController: ModalController,
    private navController: NavController,
    private calendarService: CalendarService<D>,
    private amsDataService: AmsDataService
  ) {
    this.subscriptionList.push(
      this.officeLocationService.currentOffice.subscribe((office) => {
        this.currentOffice = office.current;
      })
    );
    this.subscriptionList.push(
      this.amsDataService.isModifyFlow.subscribe((isModifyFlow) => {
        this.isModifyFlow = isModifyFlow;
      })
    );
  }

  public ngOnInit() {
    this.currentOffice = this.officeLocationService.getCurrentOffice();
  }

  public ngOnDestroy() {
    if (Utils.isArrayWithLength(this.subscriptionList)) {
      this.subscriptionList.forEach((s) => s.unsubscribe());
    }
  }

  //#endregion Initialization

  //#region Action handlers

  public goToFinalizeView(appointmentTimeSlot: AppointmentTimeSlot): void {
    this.appointmentTimeSlotService.pushCurrentTimeSlot(appointmentTimeSlot);
    const appointment = this.amsDataService.appointmentDetails?.value
      ? this.amsDataService.appointmentDetails.value
      : ({} as IAppointmentDetails);
    appointment.startTime = appointmentTimeSlot.StartUtcDate;
    appointment.endTime = appointmentTimeSlot.EndUtcDate;
    appointment.timeZone = appointmentTimeSlot.timeZone;
    // avoids creating appointment when selecting a timeslot
    this.amsDataService.pushTentativeAppointmentDetails(appointment);
    this.navController.navigateForward(['/appointments/finalize']);
  }

  handleChangeAction = (action: string) => {
    this.amsDataService.rootPage.value === null
      ? (this.rootPage = '/appointments')
      : (this.rootPage = this.amsDataService.rootPage.value);
    if (action === 'close') {
      this.displayCancelConfirm();
    } else {
      this.appointmentTimeSlotService.clearCurrentState();
      this.officeLocationService.clearCurrentState();
      this.router.navigate([this.rootPage]);
    }
  };

  //#endregion Action handlers

  //#region Helpers

  private clearAndRouteToAppointments = () => {
    this.appointmentTimeSlotService.clearDataService();
    this.officeLocationService.clearCurrentState();
    this.amsDataService.clearAppointmentDataService();
    this.calendarService.clearDate();
    this.modalController.dismiss();
    this.router.navigate([this.rootPage]);
  };

  private displayCancelConfirm = () => {
    from(
      this.modalController.create({
        component: TwoActionModalComponent,
        componentProps: {
          modalHeader:
            'Are you sure you want to exit before scheduling an appointment?',
          confirmAction: this.clearAndRouteToAppointments,
          confirmText: 'Yes',
          cancelText: 'No'
        },
        cssClass: 'twoActionModal'
      })
    ).subscribe((modal) => {
      modal.present();
    });
  };

  //#endregion Helpers
}
